import { isOpenDialogPayload } from '../../../../pimster-dialog/pimster-dialog.types';
import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';
import { InternalOpenDialogPayload } from './types';

export const internalOpenDialogPayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.OpenDialog
> = (payload: unknown): payload is InternalOpenDialogPayload =>
  isOpenDialogPayload(payload);
